// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__Ee21m","Logo_heading":"Logo_Logo_heading__JWpB7","Logo_asset":"Logo_Logo_asset__ivHQX"};